import styled, { css } from "styled-components";

export const TextAreaStyled = styled.textarea`
  border: none;
  width: 100%;
  max-height: 48px;
  border-radius: 8px;
  margin-top: 12px;
  padding: 6px 12px;
  font-size: 0.9em;
  background-color: #eaebed;
`;
export const InputStyled = styled.input`
  border-radius: 8px;
  background-color: #eaebed;
  height: 4vh;
  width: 45%;
  padding: 10px;
  margin: 5px;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;
export const MoreInfoStylrd = styled.div`
  border-radius: 8px;
  background-color: #eaebed;
  margin: 10px 0;
  padding: 5px;
  text-align: center;
  font-weight: 999;
  cursor: pointer;
`;